import { FormattedMessage } from 'react-intl';
import {
  useGetTicketsForTraveller,
  getGetTicketsForTravellerQueryKey,
  IssuedTicketFindResultDTO,
} from '@/api/trafikportalen';
import { TicketListItem } from '../Tickets/TicketListItem';
import { Loading } from '../Loading';
import { VirtualizedList } from '../VirtualizedList';
import { useCallback, useMemo } from 'react';
import { useVisibleTicketsUpdater } from '@/hooks/useVisibleTicketsUpdater';

interface Props {
  travellerId: string;
}

export const TravellerTickets = ({ travellerId }: Props) => {
  const { data: tickets, isLoading } = useGetTicketsForTraveller(travellerId);

  const sortedTickets = useMemo(() => {
    if (!tickets) return [];

    return tickets.sort(
      (a, b) =>
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime(),
    );
  }, [tickets]);

  const handleVisibleItemsChange = useVisibleTicketsUpdater({
    queryKey: getGetTicketsForTravellerQueryKey(travellerId),
  });

  const renderTicketListItem = useCallback(
    (ticket: IssuedTicketFindResultDTO) => {
      return (
        <TicketListItem
          key={ticket.id}
          ticket={ticket}
          showTravellerName={false}
        />
      );
    },
    [],
  );

  if (isLoading) {
    return <Loading />;
  }

  return (
    <div className="flex min-h-0 grow flex-col">
      <h2>
        <FormattedMessage defaultMessage="Tilldelade biljetter" />
      </h2>
      <VirtualizedList
        count={sortedTickets.length}
        countName="biljetter"
        filteredItems={sortedTickets}
        totalItems={tickets ?? []}
        renderItem={renderTicketListItem}
        getItemKey={(ticket) => ticket.id}
        onVisibleItemsChange={handleVisibleItemsChange}
      />
    </div>
  );
};
